import { concat, filter, find, some } from 'es-toolkit/compat';
import { Procedure } from 'interfaces/procedure';

import { assignManifestDraftCaseIds, ManifestCaseTarget, ManifestDialogUrlState } from './dialogState';
import { removeSlidesFromManifestCases } from './manifestResolution';

export const updateManifestCaseTarget = ({
  previousState,
  currentDraftCases,
  slideId,
  previousTarget,
  target,
}: {
  previousState: ManifestDialogUrlState;
  currentDraftCases: Procedure[];
  slideId: string;
  previousTarget: ManifestCaseTarget;
  target: ManifestCaseTarget;
}): ManifestDialogUrlState => {
  const nextState = {
    ...previousState,
    existingCaseAssignmentsBySlideId: {
      ...previousState.existingCaseAssignmentsBySlideId,
      [slideId]: target,
    },
  };
  if (target !== 'new' || previousTarget === 'new') return nextState;
  const displayedCase = find(currentDraftCases, (procedure) => some(procedure.slides, { id: slideId }));
  if (!displayedCase) return nextState;
  const [detachedCase] = assignManifestDraftCaseIds({
    cases: [{ ...displayedCase, slides: filter(displayedCase.slides, { id: slideId }) }],
    retainedCases: concat(
      previousState.uploadedManifestCases || [],
      previousState.manualManifestCases || [],
      currentDraftCases
    ),
    casePatchesById: previousState.casePatchesById,
  });
  return {
    ...nextState,
    uploadedManifestCases: removeSlidesFromManifestCases(previousState.uploadedManifestCases || [], [slideId]),
    manualManifestCases: concat(
      removeSlidesFromManifestCases(previousState.manualManifestCases || [], [slideId]),
      detachedCase
    ),
  };
};
